const gridLogin = {
 text1: 'Olá ',
 text2: ', o seguinte acesso será inserido em sua conta:'
};

export default gridLogin;
